module.exports = __webpack_public_path__ + "media/images/recipes/vegan_sashimi_salmon-81550874235f2ba149778360f1d0a4ac.pdf";